import React, {PropTypes, Component} from 'react';
import {connect} from 'react-redux';

import Modal from './Modal';
import TextField from './c_TextField';
import MaskedTextField from './c_MaskedTextField';

import Button from './Button';
import DropDownMenu from './c_DropDownMenu';
import SimpleDropDownMenu from './SimpleDropDownMenu';
import CheckList from './c_CheckList';

import { validate, validateField } from '../../modelValidator';
import EmployeeModel from '../../react/admin/Settings/User/Create/model';

import { get, pick, filter, uniq, map } from 'lodash';

@connect((state) => {
  return {
    staticData: state.staticData,
    currentUser: state.user,
    sysAdminRole: state.staticData.employeeRoles.find(r => r.hardcodelink === 'SYSTEM_ADMINISTRATOR'),
    employeeRole: state.staticData.employeeRoles.find(r => r.hardcodelink === 'EMPLOYEE')
  };
})
export default class UserForm extends Component {
  static propTypes = {
    title: PropTypes.string,
    closeFunc: PropTypes.func.isRequired,
    staticData: PropTypes.object,
    saveFunc: PropTypes.func.isRequired,
    employee: PropTypes.object,
    employees: PropTypes.object,
    renderFields: PropTypes.array,
    formClassName: PropTypes.string,
    currentUser: PropTypes.object,
    sysAdminRole: PropTypes.object,
    employeeRole: PropTypes.object,
  };

  constructor() {
    super();

    this.handleUI = ::this.handleUI;
    this.handleDropDownMenuUI = ::this.handleDropDownMenuUI;
    this.handleChange = ::this.handleChange;
    this.validate = ::this.validate;

    this.statusMenuItems = [
      { value: 'enabled', primaryText: 'Active'},
      { value: 'pending', primaryText: 'Inactive User'}
    ];

    this.weightMenuItems = [
      { primaryText: 'Select', value: null },
      { primaryText: 1, value: 1 },
      { primaryText: 2, value: 2 },
      { primaryText: 3, value: 3 },
      { primaryText: 4, value: 4 },
      { primaryText: 5, value: 5 },
      { primaryText: 6, value: 6 },
      { primaryText: 7, value: 7 },
      { primaryText: 8, value: 8 },
      { primaryText: 9, value: 9 },
      { primaryText: 10, value: 10 }
    ];

    this.state = {
      isDirty: false,
      submitted: false,
      userForm: {},
    };

    this.theRealDefaultRoles = [];

  }

  componentWillMount() {
    // update the state with pre-filled fields if editing a user
    if (this.props.employee) {
      this.setState({ userForm: pick(
        this.props.employee,
        [
          'id',
          'firstName',
          'lastName',
          'title',
          'email',
          'direct_dial',
          'cellphoneNumber',
          'roles',
          'state',
          'activeState',
          'categories',
          'weight',
          'defaultRole'
        ]
      )});
    }
  }


  validate(prop) {

    if (!this.state.submitted) {
      return;
    }

    if(prop === 'email' && this.state.emailDuplicate === true) {
      return 'E-mail is duplicate.';
    }

    const validation = validateField(get(this.state.userForm, prop), EmployeeModel()[prop]);
    return validation[0];

  }

  handleChange(prop) {
    return (event, value) => {
      const userForm = {...this.state.userForm};
      userForm[prop] = value;
      this.setState({ userForm });
    };
  }

  handleUI(prop, label) {

    return {
      'data-id': prop,
      defaultValue: (this.props.employee && this.props.employee[prop]),
      floatingLabelText: label,
      floatingLabelFixed: true,
      onBlur: this.handleChange(prop),
      isDirty: this.state.submitted,
      errorText: this.validate(prop),
    };
  }

  handleDropDownMenuUI(prop, menuItems, label) {
    return {
      ...this.handleUI(prop, label),
      menuItems
    };
  }

  save() {
    const errors = validate(this.state.userForm, EmployeeModel());
    this.setState({submitted: true, emailDuplicate: false});

		if (errors.length > 0) {
      return;
    }

    // pass up form fields in state to parent container;
    const formFields = this.state.userForm;
    formFields.roles = uniq([2].concat(formFields.roles || [])); // Role 2 is Employee.

    if(this.props.saveFunc) {

      this.props.saveFunc(formFields)
        .then(() => {
          this.props.closeFunc && this.props.closeFunc();
        }).catch((err) => {
            const errorMessage = get(err, 'body.errors[0].errorMessage');
            if(errorMessage === 'EMAIL_DUPLICATE') {
              this.setState({ emailDuplicate: true });
            }
            console.error('err catched', errorMessage);
        });
    }

  }

  render() {

    const {
      title,
      closeFunc,
      staticData,
      employees
    } = this.props;

    const defaultCategories = get(this.state, 'userForm.categories', []);

    const shouldRender = prop => this.props.renderFields ? this.props.renderFields.includes(prop): true;
    const industryTypesList = filter(staticData.industryTypesList, item => item.category !== null);
    const categoriesMenuItems = map(industryTypesList, (item) => pick(item, ['id', 'name']));

     // don't include Employee or Sysadmin (if current user is not a Sysadmin) in selected roles (state will still retain this value)
    let defaultRoles = get(this.state, 'userForm.roles', [])
      .filter(role => role !== this.props.employeeRole.id);

    // remove sysadmin unless current user is a sysadmin
    if (!this.props.currentUser.roles.includes(this.props.sysAdminRole.name)) {
      defaultRoles = filter(defaultRoles, (role) => role !== this.props.sysAdminRole.id);
    }

    let filteredRoles = filter(staticData.employeeRoles, (role) =>
      role.hardcodelink !== 'APPLICANT'
      && role.hardcodelink !== 'CLIENT'
      && role.hardcodelink !== 'EMPLOYEE');

    // take out sysadmin unless current user is a sysadmin
    if (!this.props.currentUser.roles.includes(this.props.sysAdminRole.name)) {
      filteredRoles = filter(filteredRoles, (role) => role.hardcodelink !== 'SYSTEM_ADMINISTRATOR');
    }

    // populate list of default roles, filtering out those already in use.
    this.theRealDefaultRoles = staticData.employeeRoles.filter(x => x.isDefaultRole === true);
    const defaultRolesInUse = employees.filter(x => x.defaultRole !== null && x.id !== get(this.props, 'employee.id', -1)).map(y => y.defaultRole);
    this.theRealDefaultRoles = this.theRealDefaultRoles.filter(x => defaultRolesInUse.filter(y => y === x.id).length===0);
    this.theRealDefaultRoles.push({id:null, name:'None'});

    return (
      <Modal onClickOut={closeFunc}>
        <div className='settings-user-create'>
          <h1>{title}</h1>
          <div className={`settings-user-create-form ${this.props.formClassName ? this.props.formClassName : 'three-columns'}`}>
            {
              shouldRender('firstName') &&
              <div className='control'>
                <TextField {...this.handleUI('firstName', 'First Name')}/>
              </div>
            }
            {
              shouldRender('lastName') &&
              <div className='control'>
              <TextField {...this.handleUI('lastName', 'Last Name')}/>
              </div>
            }
            {
              shouldRender('title') &&
              <div className='control'>
                <TextField {...this.handleUI('title', 'Title')}/>
              </div>
            }
            {
              shouldRender('email') &&
              <div className='control'>
                <TextField {...this.handleUI('email', 'Email')}/>
              </div>
             }
             {
              shouldRender('direct_dial') &&
              <div className='control'>
                <MaskedTextField
                  hideMaskChar
                  mask='(999) 999-9999'
                  {...this.handleUI('direct_dial', 'Contact Number')} />
              </div>
            }
            {
            shouldRender('cellphoneNumber') &&
            <div className='control'>
             <MaskedTextField
                hideMaskChar
                mask='(999) 999-9999'
                {...this.handleUI('cellphoneNumber', 'Cell Number')} />
            </div>
            }
            {
            shouldRender('roles') &&
            <div className='control'>
             <CheckList
                data-id='role'
                defaultValue={defaultRoles}
                floatingLabelText={'Role'}
                onBlur={this.handleChange('roles')}
                isDirty={this.state.submitted}
                errorText={this.validate('roles')}
                menuItems={filteredRoles}

              />
            </div>
            }
            { shouldRender('state') &&
            <div className='control'>
             <SimpleDropDownMenu {...this.handleDropDownMenuUI('state', staticData.stateList, 'Location')}
                underlineStyle={{margin: '-1px 0px'}}
                iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                labelStyle={{paddingLeft: '0px'}}
              />
            </div>
            }
            { shouldRender('Status') &&
            <div className='control'>
                <DropDownMenu
                {...this.handleDropDownMenuUI('activeState', this.statusMenuItems, 'Status')}/>
            </div>
            }
            { shouldRender('categories') &&
              <div className='control'>
                <CheckList
                  data-id='categories'
                  defaultValue={defaultCategories}
                  floatingLabelText={'Category'}
                  onBlur={this.handleChange('categories')}
                  isDirty={this.state.submitted}
                  errorText={this.validate('categories')}
                  menuItems={categoriesMenuItems}
                />
              </div>
            }
            { shouldRender('weight') &&
              <div className='control'>
                <SimpleDropDownMenu {...this.handleDropDownMenuUI('weight', this.weightMenuItems, 'Weight')}
                  underlineStyle={{margin: '-1px 0px'}}
                  iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                  labelStyle={{paddingLeft: '0px'}}
                />
              </div>
            }

            { shouldRender('defaultRole') &&
            <div className='control'>
              <SimpleDropDownMenu {...this.handleDropDownMenuUI('defaultRole', this.theRealDefaultRoles, 'Default Role')}
                                  underlineStyle={{margin: '-1px 0px'}}
                                  iconStyle={{right: '0px', fill: 'rgb(33, 35, 38)'}}
                                  labelStyle={{paddingLeft: '0px'}}
              />
            </div>
            }



          </div>

          <div className='grid grid-actions'>
            <div className='row'>
              <div className='col'>
                <Button
                  onClick={closeFunc}
                  data-id='cancel'
                  className='button-secondary button-secondary-cancel'
                  label='CANCEL'/>
              </div>
              <div className='col'>
                <Button
                  data-id='save-user'
                  onClick={::this.save}
                  className='button-main button-main-save-user'
                  label='SAVE'/>
              </div>
            </div>
          </div>

        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/common/components/UserForm.js